import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const CONFLICT_TAG = ['addRegardless', 'allLessonNotAdd', 'conflictNotAdd']

export const schema = Joi.object().keys({
  "lesson_id_list": Joi.array().items(Joi.number().integer()).required(),
  "student_id_list": Joi.array().items(Joi.number().integer()).allow(''),
  "teacher_id_list": Joi.array().items(Joi.number().integer()).allow(''),
  "classroom_id": Joi.number().integer().allow(''),
  "calendar_color": Joi.string().allow(''),
  "start_time": Joi.string().allow(''),
  "end_time": Joi.string().allow(''),
  "note": Joi.string().allow(''),
  "conflict_tag": Joi.string().valid(CONFLICT_TAG).allow(''),
  "note": Joi.string().allow(''),
});

export default function updateMultiLesson(classId, classInfo) {

  if(!classId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing class ID')
      })
    })
  }

  let validateResult = Joi.validate(classInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...classInfo,
    conflict_tag: CONFLICT_TAG.indexOf(classInfo.conflict_tag)
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_multi_lsns/${classId}/`,
		'method': 'PUT',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/lesson/updateMultiLesson.js